import React from 'react';

const getBadgeProps = (state) => {
    switch (state?.toLowerCase()) {
        case 'draft':
            return { label: 'Brouillon', className: 'bg-yellow-100 text-yellow-800' };
        case 'verify':
            return { label: 'En attente', className: 'bg-yellow-100 text-green-800' };
        case 'done':
            return { label: 'Validé', className: 'bg-green-100 text-green-800' };
        case 'refused':
            return { label: 'Refusé', className: 'bg-red-100 text-red-800' };
        case 'cancel':
            return { label: 'Annulé', className: 'bg-red-100 text-red-800' };
        default:
            return { label: state, className: 'bg-gray-100 text-gray-800' };
    }
};

const PayslipStateBadge = ({ state }) => {
    if (!state) return null;
    const { label, className } = getBadgeProps(state);
    return (
        <span className={`px-2 py-1 rounded-full text-xs font-medium ${className}`}>
            {label}
        </span>
    );
};

export default PayslipStateBadge;